import {
  GOOD,
  NO_MATCH,
  PRE_APPROVED,
  REALLY_GOOD,
  UNABLE,
  UNABLE_LONGER_TERM,
  UNLIKELY
} from 'constants/general';
import { DIP_GREAT_NEWS, DIP_NO_MATCH, DIP_UNLIKELY_RESULT } from 'constants/paths';

export const CREDIT_DECISION_ROUTES_MAP = {
  [UNABLE_LONGER_TERM]: DIP_UNLIKELY_RESULT,
  [UNLIKELY]: DIP_UNLIKELY_RESULT,
  [UNABLE]: DIP_UNLIKELY_RESULT,
  [NO_MATCH]: DIP_NO_MATCH,
  [REALLY_GOOD]: DIP_GREAT_NEWS,
  [PRE_APPROVED]: DIP_GREAT_NEWS,
  [GOOD]: DIP_GREAT_NEWS
};
